"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _button = _interopRequireDefault(require("promo-js/lib/button"));

const AppButton = props => {
  const {
    className,
    disabled,
    isLoading,
    children
  } = props,
        otherProps = (0, _objectWithoutProperties2.default)(props, ["className", "disabled", "isLoading", "children"]);
  return /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
    className: (0, _classnames.default)('app-button', {
      'app-button--disabled': disabled,
      'app-button--loading': isLoading
    }, className)
  }, otherProps), isLoading ? /*#__PURE__*/_react.default.createElement("span", {
    className: "app-button__loader"
  }) : children);
};

AppButton.propTypes = {
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  isLoading: _propTypes.default.bool,
  children: _propTypes.default.node
};
AppButton.defaultProps = {
  className: '',
  disabled: false,
  isLoading: false,
  children: null
};
var _default = AppButton;
exports.default = _default;